import {
  GetComplianceMetricsInput,
  GetComplianceTrendMetricsInput,
} from "src/gql/graphql"
import { graphqlClient } from "@myvp/shared/src/functions/request"
import { graphql } from "src/gql"

const getComplianceMetricsQuery = graphql(/* GraphQL */ `
  query getComplianceMetrics($input: GetComplianceMetricsInput!) {
    getComplianceMetrics(input: $input) {
      summaryMetrics {
        dimensionItem {
          __typename
          id
          label
          ... on SiteDimensionItem {
            countryId
            countryLabel
          }
          ... on ParticipantDimensionItem {
            siteId
            siteLabel
            countryLabel
            status
          }
        }
        compliancePercentage
        totalVolume
      }
    }
  }
`)

const getComplianceFilterOptionsQuery = graphql(/* GraphQL */ `
  query getComplianceFilterOptions {
    getComplianceFilterOptions {
      filterOptions {
        countries {
          id
          label
        }
        sites {
          countryId
          countryLabel
          sites {
            id
            label
          }
        }
        participantsBySite {
          siteId
          siteLabel
          participants {
            id
            label
          }
        }
        participantsByGroup {
          groupId
          groupLabel
          groupTypeLabel
          participants {
            id
            label
          }
        }
        events {
          id
          label
        }
        surveysByType {
          surveyType
          surveys {
            id
            label
          }
        }
      }
    }
    getComplianceSettings {
      threshold
    }
  }
`)

const getComplianceTrendMetricsQuery = graphql(/* GraphQL */ `
  query getComplianceTrendMetrics($input: GetComplianceTrendMetricsInput!) {
    getComplianceTrendMetrics(input: $input) {
      trendMetrics {
        dimensionItem {
          __typename
          id
          label
          ... on SiteDimensionItem {
            countryId
            countryLabel
          }
          ... on ParticipantDimensionItem {
            siteId
            siteLabel
            status
          }
        }
        trendData {
          trendPoints {
            periodStartDate
            periodEndDate
            compliancePercentage
            totalSurveys
          }
          percentageChange
        }
      }
    }
  }
`)

export const getComplianceMetrics = async (args: GetComplianceMetricsInput) => {
  const data = await graphqlClient.request(getComplianceMetricsQuery, {
    input: args,
  })
  return data.getComplianceMetrics
}

export const getComplianceFilterOptions = async () => {
  const data = await graphqlClient.request(getComplianceFilterOptionsQuery)
  return {
    ...data.getComplianceFilterOptions,
    settings: data.getComplianceSettings,
  }
}

export const getComplianceTrendMetrics = async (
  args: GetComplianceTrendMetricsInput
) => {
  const data = await graphqlClient.request(getComplianceTrendMetricsQuery, {
    input: args,
  })
  return data.getComplianceTrendMetrics
}
